import React, {Component} from 'react';
import {history} from "../store/store";
import _ from "lodash";
import GobLogo from '../assets/images/gobmxlogo.svg';
import SecureLayout from "./secure";
import Notification from './../elements/notification';
import Navigation from "../elements/navigation/navigation";
import UserDropdown from "../elements/user-opts-dropdown";
import Subnavigation from "../elements/navigation/subnavigation";
import Subcdmnavigation from "../elements/navigation/subnavigation-cdms";


export default function (SecuredComponent, data) {
	class BaseLayout extends Component {

		render() {
			const { notifications, location, session, menu } = this.props;
			const { modality, municipality, state } = this.props.match.params;
			return [
				<Navigation agencies={{...session.user.agencies}} cdms={{...session.user.cdms}} items={{...session.user.menu}} show={menu.view} location={{...location}} key={`app-navigation-sidebar`} />,

				<div className="main-content" key="main-website-content">
					<nav className="navbar is-dark secondary-navigation">
						<div className="navbar-menu navbar-item">
							<img src={GobLogo} alt="gob.mx" className="app-gov-logo--image" />
						</div>

						{session.user.version ?
						<div className="navbar-menu navbar-item">
							<h6 className="title is-6 has-text-centered has-text-white">{session.user.version.name}</h6>
						</div>:''}

						<button className="main-nav--close" onClick={() => this.toggleMenu()}>
							{menu.view ? <i className="fa fa-chevron-left" /> : <i className="fa fa-chevron-right" />}
						</button>
						<UserDropdown data={{...session.user.profile}} />
					</nav>

					{(data && data.subnav) &&
					<Subnavigation
						icon={data.subnav.icon}
						name={data.subnav.name}
						actions={data.subnav.actions}
						stateNav={data.stateNav}
						modality={modality}
						filter={this.state.filterType}
						filterChange={this.filterChange}
						stateChange={this.stateChange}
						agencies={session.user.agencies}
						changeStates={this.changeStates}
						changeMuns={this.changeMuns}
						agenciable={{state: this.state.showState, municipality: municipality}} />
					}

					{(data && data.subcdmnav) &&
					<Subcdmnavigation
						icon={data.subcdmnav.icon}
						name={data.subcdmnav.name}
						actions={data.subcdmnav.actions}
						stateNav={data.stateNav}
						stateChange={this.stateChange}
						cdms={session.user.cdms}
						changeStates={this.changeCdmStates}
						changeMuns={this.changeCdmMuns}
						agenciable={{state: state, municipality: municipality}} />
					}

					<section className="app-layout--content">

						<h1 className="title is-1 main-title" dangerouslySetInnerHTML={{__html: data && data.title ? data.title : ''}}></h1>

						{notifications.active &&
						<div className="columns is-centered">
							<div className="column is-10-desktop">
								<Notification {...notifications} />
							</div>
						</div>}
						<div className="app-container">
							<SecuredComponent {...this.props} />
						</div>
						<div style={{height:'50px'}}>&nbsp;</div>
					</section>
				</div>
			]

		}

		constructor(props) {
			super(props);
			this.state = {
				profileShow: false,
				showState: props.match.params.state,
				filterType: 'all_projects'
			}
			this.toggleMenu = this.toggleMenu.bind(this);
			this.filterChange = this.filterChange.bind(this);
			this.stateChange = this.stateChange.bind(this);
			this.changeStates = this.changeStates.bind(this);
			this.changeMuns = this.changeMuns.bind(this);
			this.changeCdmStates = this.changeCdmStates.bind(this);
			this.changeCdmMuns = this.changeCdmMuns.bind(this);
		}

		componentWillReceiveProps(nextProps){
			if(nextProps.match.params.state !== this.props.match.params.state){
				this.stateChange(nextProps.match.params.state)
			}
		}

		stateChange(entity) {
			return this.setState({
				showState: entity
			});
		}

		filterChange(e){
			return this.setState({
				filterType: e.target.value
			})
		}

		changeStates(state) {
			let url = _.split(history.location.pathname, '/', 5);
			if(url[4]==='administrativo' || url[4]==='juridica'){
				url[5] = state;
			}else {
				url[4] = state;
			}
			url = _.join(url, '/');
			history.push(url);
			this.stateChange(state);
		}

		changeMuns(mun) {
			let url = _.split(history.location.pathname, '/', 6);
			if(url[4]==='administrativo' || url[4]==='juridica'){
				url[5] = this.state.showState;
				url[6] = mun;
			}else {
				url[4] = this.state.showState;
				url[5] = mun;
			}
			url = _.join(url, '/');
			history.push(url);
		}

		changeCdmStates(state) {
			const {cdms} = this.props.session.user;
			let filterMun = _.filter(cdms, {agenciable_state_short: state})
			let url = _.split(history.location.pathname, '/', 5);
			url[3] = state;
			if(filterMun){
				url[4] = filterMun[0].agenciable_slug;
			}
			url = _.join(url, '/');
			history.push(url);
		}

		changeCdmMuns(state, mun) {
			let url = _.split(history.location.pathname, '/', 5);
			url[3] = state;
			url[4] = mun;
			url = _.join(url, '/');
			history.push(url);
		}

		toggleMenu() {
			let { view } = this.props.menu;
			return view === true ? this.props.hideMenu() : this.props.showMenu();
		}
	}


	return SecureLayout(BaseLayout);
}



// WEBPACK FOOTER //
// ./src/templates/base.jsx